import { CONSTANT } from "src/app/constant";
import { ReportSummaryRecommendation } from "src/app/models/models";

export function isRecommendationFormType(formType?: string): boolean {
	return (
		formType === CONSTANT.FORM_TYPE.ts_1 ||
		formType === CONSTANT.FORM_TYPE.ts_3 ||
		formType === CONSTANT.FORM_TYPE.ts_5 ||
		formType === CONSTANT.FORM_TYPE.ts_6
	);
}

export function isRecommendationTraining(rec?: ReportSummaryRecommendation): boolean {
	const type = (rec?.sessionType ?? rec?.sessionTypeDescription ?? "").toLowerCase();
	return type === "training";
}

export function recommendationSessionLabel(rec?: ReportSummaryRecommendation): string {
	if (rec?.sessionTypeDescription) return rec.sessionTypeDescription;
	const raw = rec?.sessionType ?? "";
	if (!raw) return "-";
	return raw
		.replace(/[_-]+/g, " ")
		.replace(/\s+/g, " ")
		.trim()
		.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatRecommendationYesNo(value?: boolean): string {
	if (value === true) return "Yes";
	if (value === false) return "No";
	return "-";
}

export function formatRecommendationObjective(rec?: ReportSummaryRecommendation): string {
	if (rec?.is_obj_met == null) return "-";
	return rec.is_obj_met ? "Yes" : "No";
}

export function formatRecommendationClearance(rec?: ReportSummaryRecommendation): string {
	const value = rec?.is_clear;
	if (value === "N/A" || value === "n/a") return "Not Applicable";
	if (value === true || value === "true") return "Yes";
	if (value === false || value === "false") return "No";
	return "-";
}
